module.exports = __webpack_public_path__ + "media/application/images/svgs/twitter-6c3472cf6c65573cd5cfa1aa850a282c.svg";